import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-circular-menu',
  templateUrl: './circular-menu.component.html',
  styleUrls: ['./circular-menu.component.css']
})
export class CircularMenuComponent implements OnInit {
  @Input() hasGrid: boolean = true;

  @Output() onToggleFilteringSorting: EventEmitter<any> = new EventEmitter<any>();

  @Output() onToggleVisibility: EventEmitter<any> = new EventEmitter<any>();

  @Output() onHelp: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

}
